import React, {Component} from 'react'

class HelpCA001 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />企業情報を変更する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[CA1-1]</span>画面上部のメニューの中の「日常業務」の「企業管理」(図CA1-1 参照)を押してください。</legend>
              <figcaption>図CA1-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_CA1-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[CA1-2]</span>画面の右上の「編集」(図CA1-2 参照)を押してください。</legend>
              <figcaption>図CA1-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_CA1-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[CA1-3]</span>「企業名」、「メールアドレス」、「お知らせメール受信」を入力し、「保存」ボタン(図CA1-3 参照)を押してください。</legend>
              <figcaption>図CA1-3</figcaption>
              <ul>
                <li><img alt='' src='/help/help_CA1-3.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[CA1-4]</span>メッセージが表示されるので「OK」ボタンを押してください。(図CA1-4 参照)</legend>
              <figcaption>図CA1-4</figcaption>
              <ul>
                <li><img alt='' src='/help/help_CA1-4.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default HelpCA001



// WEBPACK FOOTER //
// ./src/help/HelpCA001.js